import React, { useMemo } from 'react'
import SharedStack from '~components/shared/wrappers/shared-stack'
import { Text } from '@chakra-ui/react'
import {
    ChatMessageFieldsFragment,
    NotificationLogMessageFieldsFragment,
} from '~graphql/generated/graphql'
import EmailPreviewButton from '~components/engagement/notification-logs/notification-log-row/email-preview-button'
import { useNotificationLogsContext } from '../provider'
import {
    getMessageNotificationRefs,
    resolveNotificationPreviewContent,
} from './resolve-preview-content'

export default function NotificationEmailPreviews({
    message,
}: {
    message: ChatMessageFieldsFragment | NotificationLogMessageFieldsFragment
}) {
    const { notificationTemplates = [] } = useNotificationLogsContext()

    const notifications = useMemo(() => {
        const fromTemplates = getMessageNotificationRefs(message).map(ref =>
            resolveNotificationPreviewContent(ref, notificationTemplates),
        )

        if (message.bulk_message?.id) {
            return [
                {
                    id: message.bulk_message.id,
                    name: message.bulk_message.name,
                    subject:
                        'subject' in message.bulk_message
                            ? message.bulk_message.subject
                            : null,
                    body:
                        'body' in message.bulk_message
                            ? message.bulk_message.body
                            : null,
                    email_body:
                        'email_body' in message.bulk_message
                            ? message.bulk_message.email_body
                            : null,
                    isBulkMessage: true as const,
                },
                ...fromTemplates.map(n => ({ ...n, isBulkMessage: false as const })),
            ]
        }

        return fromTemplates.map(n => ({ ...n, isBulkMessage: false as const }))
    }, [message, notificationTemplates])

    if (!notifications.length) return null

    return (
        <SharedStack>
            {notifications.map(email => (
                <SharedStack row key={email.id} spacing={1}>
                    <Text>Email sent for</Text>
                    <EmailPreviewButton
                        message={message}
                        notification={email}
                        isBulkMessage={email.isBulkMessage}
                    />
                </SharedStack>
            ))}
        </SharedStack>
    )
}
